import { useI18n } from '@oneaudi/i18n-context';
import { useFormattedDate } from '../../hooks/text/useFormattedDate';
export const getAvailabilityDetails = (carType, businessModel, availableFrom, availableFromCode, reservation, city) => {
    const generateAvailabilityLabels = () => {
        if (reservation) {
            return {
                textKey: `stockcars.${carType}.${businessModel}.availability.reserved`,
                replacements: { city },
                color: 'negative',
            };
        }
        if (availableFromCode === 'soon') {
            return {
                textKey: `stockcars.${carType}.${businessModel}.availability.${availableFromCode}`,
                replacements: { availableFrom, city },
                color: 'notice',
            };
        }
        if (availableFromCode === 'date') {
            const modifiedDate = new Date(availableFrom).getTime();
            const formattedDate = useFormattedDate(modifiedDate);
            return {
                textKey: `stockcars.${carType}.${businessModel}.availability.${availableFromCode}`,
                replacements: { date: formattedDate, city },
                color: 'notice',
            };
        }
        return {
            textKey: `stockcars.${carType}.${businessModel}.availability.now`,
            replacements: { city },
            color: 'positive',
        };
    };
    const { textKey, replacements, color } = generateAvailabilityLabels();
    const availableTextKey = useI18n({
        id: textKey,
        defaultMessage: '',
    });
    const availabilityLabel = Object.entries(replacements).reduce((label, [key, value]) => label.replace(`{{${key}}}`, value || ''), availableTextKey);
    return { color, availableTextKey, availabilityLabel };
};
